import React from 'react';
import { motion } from 'framer-motion';
import { renderCell } from '../utils/helpers';

const isActionsColumn = (column) =>
  column.sticky === true ||
  column.accessor === 'actions' ||
  column.header === 'Actions';

const stickyHeaderClass =
  'sticky right-0 z-20 bg-gray-50 shadow-[-8px_0_12px_-8px_rgba(0,0,0,0.12)]';
const stickyCellClass =
  'sticky right-0 z-10 bg-white group-hover:bg-gray-50 shadow-[-8px_0_12px_-8px_rgba(0,0,0,0.12)]';

const Table = ({ columns, data, onRowClick = null, emptyMessage = 'Aucune donnée disponible' }) => {
  return (
    <div className="overflow-x-auto -mx-3 sm:mx-0">
      <div className="inline-block min-w-full align-middle">
        <div className="overflow-hidden shadow-sm ring-1 ring-black ring-opacity-5 sm:rounded-lg">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                {columns.map((column, index) => (
                  <th
                    key={index}
                    scope="col"
                    className={`px-3 sm:px-4 md:px-6 py-2 sm:py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider ${
                      isActionsColumn(column) ? stickyHeaderClass : ''
                    }`}
                  >
                    {column.header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {data.length === 0 ? (
                <tr>
                  <td
                    colSpan={columns.length}
                    className="px-3 sm:px-6 py-6 sm:py-8 text-center text-gray-500 text-sm"
                  >
                    {emptyMessage}
                  </td>
                </tr>
              ) : (
            data.map((row, rowIndex) => (
              <motion.tr
                key={rowIndex}
                initial={{ opacity: 0.95 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.1 }}
                onClick={() => onRowClick && onRowClick(row)}
                className={`group ${onRowClick ? 'hover:bg-gray-50 cursor-pointer' : 'hover:bg-gray-50'}`}
              >
                    {columns.map((column, colIndex) => (
                      <td
                        key={colIndex}
                        className={`px-3 sm:px-4 md:px-6 py-3 sm:py-4 whitespace-nowrap text-xs sm:text-sm text-gray-900 ${
                          isActionsColumn(column) ? stickyCellClass : ''
                        }`}
                      >
                        {column.render ? column.render(row) : renderCell(row[column.accessor])}
                      </td>
                    ))}
                  </motion.tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Table;

